module.exports = __webpack_public_path__ + "media/images/sponsor/sponsor-26466924e7378664d8ee651dfdfafbfb.png";